import React from "react";
import { forwardRef } from "react";

import  { 
  AboutContainer, 
  AboutTextWrapper, 
  AboutTitle, 
  AboutText, 
  Credits, 
  CreditLink, 
  } from "../styled-components/aboutstyle";

const About = forwardRef((props, aboutRef)=> {
  return (
    <AboutContainer ref={aboutRef}>
      <AboutTextWrapper>
        <AboutTitle>About me</AboutTitle>
        <AboutText>
          I work within visual arts, performing arts and the entanglements in between. My curatorial practices evolves 
          around the performative and temporal boundaries of the exhibition format itself. In my academic work I have researched 
          acts of framing in curatorial practice, the performative acts of exhibitions and doctrines of temporal formats in experiencing art.
          I worked as a curator at <CreditLink href="https://magasin3.com/" target="_blank" 
          rel="noopener noreferrer"> Magasin III</CreditLink>, Stockholm, one of the leading contemporary art museums in Europe.  
          I was the producer of Stockholm based performing arts company O (collaboration between <CreditLink 
          href="https://www.poste-restante.se/index.html" target="_blank" rel="noopener noreferrer"> Poste Restante</CreditLink> and 
          <CreditLink href="https://osynligateatern.com/" target="_blank" rel="noopener noreferrer"> Osynliga Teatern</CreditLink>),
          and worked with all of Marina Abramovics reperformance productions during her the The Cleaner tour (2016-2019), 
          collaborating with art insitutions in 7 european countries. 
          I have also worked at Moderna Museet, Stockholm, Uppsala Art Museum, galleries and auction houses. 
          I have a bachelor degree in art history from Uppsala University, a masters degree from the 
          International Curator Program at Stockholm University and completed the Technigo Web Developer Bootcamp in 2022. 
          </AboutText>
        <Credits>© 2024. Website built by Sofia Ringstedt and graphic design made by 
          <CreditLink href="http://www.jacoblandahl.com/" target="_blank" rel="noopener noreferrer"> Jacob Landahl.</CreditLink></Credits>
      </AboutTextWrapper>
    </AboutContainer>
  )
})

export default About;